import { useEffect, useRef, type ReactNode } from 'react';
import useReveal from '@/hooks/useReveal';

interface PageShellProps {
  title: string;
  description: string;
  children: ReactNode;
  theme?: 'default' | 'orange';
}

/**
 * Page content wrapper. Header, Footer and scroll handling live in the
 * persistent TransitionLayout so they never remount between routes.
 */
export default function PageShell({ title, description, children, theme = 'default' }: PageShellProps) {
  const mainRef = useRef<HTMLElement>(null);
  useReveal(mainRef);

  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', description);
  }, [title, description]);

  return (
    <main ref={mainRef} tabIndex={-1} className={`flex-1 outline-none ${theme === 'orange' ? 'theme-orange' : ''}`}>
      {children}
    </main>
  );
}